import { render, staticRenderFns } from "./couponEdit.vue?vue&type=template&id=1560671d&scoped=true&"
import script from "./couponEdit.vue?vue&type=script&lang=js&"
export * from "./couponEdit.vue?vue&type=script&lang=js&"
import style0 from "./couponEdit.vue?vue&type=style&index=0&id=1560671d&scoped=true&lang=css&"
import style1 from "./couponEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560671d",
  null
  
)

export default component.exports